// Access granted by role rather than by a ModulePermission row.
// Branding Management has no permission row behind it at all, and Department
// Management is shown to facility staff regardless of what their role was
// granted. Kept here so the landing tiles and RestrictedRoute cannot drift:
// showing a tile whose route then denies access is the failure this prevents.
export const FACILITY_ROLES = ["facility admin", "facility user"];

// Tile ids in the normalized form the landing page compares against.
export const ROLE_ENTITLED_TILE_IDS = ["manage_branding", "manage_departments"];

// Permission names spelled as RestrictedRoute receives them.
export const ROLE_ENTITLED_PERMISSIONS = ["manage departments"];

// Two vocabularies to match: Role.name from get_logged_in_user_info, and the
// login role held in sessionStorage as roleType.
export const hasFacilityRole = (...values) =>
  values.some((value) =>
    FACILITY_ROLES.includes(String(value || "").trim().toLowerCase())
  );
